import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";

const env = import.meta.env.VITE_ENV || "prod";

if ("prod" === env) {
  LogRocket.init("sks4it/workload");
  setupLogRocketReact(LogRocket);
}

const root = createRoot(document.getElementById("root"));
root.render(<App />);
